import dayjs from "dayjs";

// let lastDisplayedDate = null;
const accelerationHistory = {
  dataZoom: [
    {
      type: "slider",
      start: 0,
      end: 100,
      show: true,
      showDetail: false,
    },
  ],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
  },
  grid: {
    left: 60,
    top: 80,
    right: 30,
    bottom: 100,
  },
  legend: {
    data: ["Accel X", "Accel Y", "Accel Z", "Accel RMS"],
    left: "center",
    icon: "roundRect",
  },
  xAxis: [
    {
      type: "category",
      name: "Time",
      nameGap: 40,
      // offset:20,
      nameLocation: "middle",
      boundaryGap: false,
      axisPointer: {
        label: {
          formatter: function (params) {
            return dayjs(params.value).format("MM-DD-YYYY HH:mm:ss");
          },
        },
        handle: {
          show: false,
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: function (value) {
          const date = new Date(value);
          const formattedDate = `${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${date
            .getDate()
            .toString()
            .padStart(2, "0")}/${date.getFullYear()}`;

          // if (formattedDate === lastDisplayedDate) {
          //   return "";
          // }
          // lastDisplayedDate = formattedDate;
          return formattedDate;
        },
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "g",
      nameGap: 40,
      nameRotate: 90,
      nameLocation: "middle",
    },
  ],
  series: [
    {
      name: "Accel X",
      type: "line",
      data: [],
      symbol: "none",
      itemStyle: {
        color: "#FF8027",
      },
      lineStyle: {
        normal: {
          width: 4,
          type: "solid",
        },
      },
    },
    {
      name: "Accel Y",
      type: "line",
      data: [],
      symbol: "none",
      itemStyle: {
        color: "#0089EC",
      },
      lineStyle: {
        normal: {
          width: 4,
          type: "solid",
        },
      },
    },
    {
      name: "Accel Z",
      type: "line",
      data: [],
      symbol: "none",
      itemStyle: {
        color: "#63D48E",
      },
      lineStyle: {
        normal: {
          width: 4,
          type: "solid",
        },
      },
    },
    {
      name: "Accel RMS",
      type: "line",
      data: [],
      symbol: "none",
      itemStyle: {
        color: "#FED60E",
      },
      lineStyle: {
        normal: {
          width: 4,
          type: "solid",
        },
      },
    },
  ],
};

export default accelerationHistory;
